import countries from "world-countries";

/**
 * Returns formatted country list
 * @param format "name" | "code" | "dialCode" (optional extension)
 */
export const getCountryList = (format = "name") => {
    return countries
        .map((country) => {
            switch (format) {
                case "code":
                    return {
                        label: country.name.common,
                        value: country.cca2,
                    };

                case "name":
                default:
                    return {
                        label: country.name.common,
                        value: country.name.common,
                    };
            }
        })
        .sort((a, b) => a.label.localeCompare(b.label));
};